export default "__VITE_ASSET__CMhL$9nM__"